module.exports = __webpack_public_path__ + "static/media/cloud-c-v3.9d58b73d.svg";